module.exports = __webpack_public_path__ + "static/media/banerCentralStock.99009964.png";